import React from "react";

const DynamicsForm = ({ blok }) => {
  console.log("dynamicsform blok:", blok);
  const { form_id, form_api_url, data_cached_form_url } = blok;
  React.useLayoutEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/usa/FormLoader/FormLoader.bundle.js";
    script.type = "text/javascript";

    document.body.appendChild(script);
  }, []);
  if (!form_id) {
    return <div>Dynamics Form ID is required</div>;
  }
  return (
    <>
      <div
        data-form-id={form_id}
        data-form-api-url={form_api_url}
        data-cached-form-url={data_cached_form_url}
      ></div>
    </>
  );
};

export default DynamicsForm;
